import { gql } from '@apollo/client';

export const getTemplateAchievementsQuery = gql`
    query GetTemplateAchievements {
        achievements(hasTemplateId: true) {
            id
            templateId
            questIds
            achievementConditions {
                metricType
                target
                value
                questIds
            }
        }
    }
`;
